
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';
import Toast from '@common/helpers/toast';
import ApiHelper from 'api-helper';

@Component({
  components: {
    PageLoader,
  },
})
export default class PopupConfirmDelete extends Vue {
  @Prop() readonly messageId: number;

  public isLoading: boolean = false;

  async confirm() {
    try {
      this.isLoading = true;
      await ApiHelper.getApi('MessageApi').deleteMessage(this.messageId);
    } catch (error) {
      this.toast(error);
    } finally {
      this.$modal.hide('popup-confirm-delete');
      this.isLoading = false;
    }
  }

  cancel() {
    this.$modal.hide('popup-confirm-delete');
  }

  private toast(error: any) {
    Toast.error(error.response.data.message);
  }
}
